import { render, staticRenderFns } from "./StartPickModal.vue?vue&type=template&id=12e471c6&"
import script from "./StartPickModal.vue?vue&type=script&lang=js&"
export * from "./StartPickModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports